import { render, staticRenderFns } from "./UpdateColorModal.vue?vue&type=template&id=9ed4bf88&scoped=true"
import script from "./UpdateColorModal.vue?vue&type=script&lang=js"
export * from "./UpdateColorModal.vue?vue&type=script&lang=js"
import style0 from "./UpdateColorModal.vue?vue&type=style&index=0&id=9ed4bf88&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ed4bf88",
  null
  
)

export default component.exports